import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function Button(props) {
  const classes = classnames(
    'btn',
    props.kind && `btn-${props.kind}`,
    props.className,
  );
  return (
    <button type="button" {...props} className={classes} />
  );
}

Button.propTypes = {
  type: PropTypes.string,
  kind: PropTypes.oneOf(['link']),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Button;
